/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import noop from 'lodash/noop';

// TODO Přejmenovat na PromiseQueue nebo rovnou nahradit za knihovnu?
// - https://github.com/sindresorhus/p-queue
/**
 * Fronta asynchronních akcí.
 * Akce se řadí do fronty a postupně vyvolávájí po obsloužení předchozích akcí (FIFO).
 */
class Queue {
  /**
   * Vytvoří instanci.
   * @returns {Queue} Nová instance.
   */
  constructor() {
    /**
     * Sřetězená promise, která se skládá z jednotlivých akcí.
     * @private
     * @type {Promise}
     */
    this.promise = Promise.resolve();
  }

  /**
   * Zařadí novou akci do fronty.
   * @param {onDequeue} cb Callback při vyřazení akce.
   * @returns {Promise.<*>} Výsledek callbacku při vyřazení akce.
   */
  enqueue(cb) {
    return new Promise((resolve) => {
      const promise =
        // Počká se na výsledek předchozích akcí.
        this.promise
          .catch(noop)
          // Prevede se požadovaná akce.
          .then(() => cb());
      // Aktualizuje se sřetězená promise o novou akci.
      this.promise = promise;
      // Vrací se výsledek po provedení požadované akce.
      return resolve(promise);
    });
  }
}

/**
 * Callback, který se vyvolává v okamžiku, kdy se akce vyřazuje z fronty.
 * @memberof Queue
 * @callback onDequeue
 * @returns {Promise.<*>} Promise s libovolným výsledkem.
 */

export default Queue;
